import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAt, faCalendarAlt, faDollarSign, faHashtag, faSave, faTimes, faUsers } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        invoice_id: '',
        invoice_date: '',
        invoice_total: 1,
        details: '',
        supplier_id: '',
        supplier_name: '',
        supplier_address: '',
        supplier_phone: '',
        suppliers: [],
        errors: [],
    }
    sessionExpired = () => {
        Swal.fire('Token has Expired!', 'Re-Login', 'info');
        window.localStorage.clear();
        window.location.href = '/';
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = async (e) => {
        e.preventDefault();
        const { invoice_id, invoice_date, invoice_total, details, supplier_id } = this.state;
        var errors = [];
        if (!invoice_id) { errors.push("error_invoice_id"); }
        if (!invoice_date) { errors.push("error_invoice_date"); }
        if (!invoice_total) { errors.push("error_invoice_total"); }
        if (!supplier_id) { errors.push("error_supplier_id"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var dataSuppliersInvoice = {
            invoice_id: invoice_id,
            invoice_date: invoice_date,
            invoice_total: invoice_total,
            details: details,
            supplier_id: supplier_id,
            user_id: window.localStorage.getItem('idusuario')
        }
        try {
            Swal.fire({
                title: 'Saving...',
                text: 'Please, wait',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const suppliersInvoicesDataRes = await authAxios.post("suppliers_invoices/register", dataSuppliersInvoice);
            if (!suppliersInvoicesDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            const { ID_INVOICE } = suppliersInvoicesDataRes.data;
            const dataAccountsPayable = {
                ...dataSuppliersInvoice,
                id_invoice: ID_INVOICE
            }
            const accountsPayableDataRes = await authAxios.post("accounts_payable/register", dataAccountsPayable)
            if (!accountsPayableDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Suppliers Invoices!',
                suppliersInvoicesDataRes.data.msj,
                'success'
            );
            this.props.history.push("/UpSuppliersInvoices/" + suppliersInvoicesDataRes.data.ID_INVOICE);
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    selectSupplier = (supplier_id, supplier_name, supplier_address, supplier_phone) => {
        Swal.showLoading();
        this.setState({
            supplier_id: '',
            supplier_name: '',
            supplier_address: '',
            supplier_phone: '',
        });
        this.setState({
            supplier_id: supplier_id,
            supplier_name: supplier_name,
            supplier_address: supplier_address,
            supplier_phone: supplier_phone
        });
        Swal.close();
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("suppliers_invoices/suppliers")
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    suppliers: dataResult.data
                });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const {
            invoice_id,
            invoice_date,
            invoice_total,
            details,
            supplier_id,
            supplier_name,
            supplier_address,
            supplier_phone,
            suppliers
        } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NEW SUPPLIER INVOICE</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>SUPPLIER INVOICE INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_id">Invoice ID.</label>
                                                    <div className={((this.errorVerify("error_invoice_id")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="invoice_id" id="invoice_id" value={invoice_id}
                                                            className={((this.errorVerify("error_invoice_total")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Invoice ID." aria-describedby="helpId"
                                                            onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Invoice Id.</small>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_total">Total</label>
                                                    <div className={((this.errorVerify("error_invoice_total")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" min="1" name="invoice_total" id="invoice_total" value={invoice_total}
                                                            className={((this.errorVerify("error_invoice_total")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Invoice Total" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Invoice Total</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_date">Invoice Date</label>
                                                    <div className={((this.errorVerify("error_invoice_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="invoice_date" id="invoice_date" value={invoice_date}
                                                            className={((this.errorVerify("error_invoice_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Invoice Date" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Invoice Date</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="invoice_status">Status</label>
                                                    <input style={{ textTransform: 'uppercase', color: "#FFFFFF", backgroundColor: "#00539B", fontWeight: "bold" }} type="text" name="invoice_status" id="invoice_status" value="IN PROCESS"
                                                        className="form-control form-control-sm text-center" placeholder="Status" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="details">Other Comments</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }}
                                                        className='form-control form-control-sm' id="details" name="details" rows='3' value={details}
                                                        onChange={this.changeValue} aria-describedby="helpId"></textarea>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>SUPPLIER INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="supplier_id">Supplier ID.</label>
                                                    <div className={((this.errorVerify("error_supplier_id")) ? "is-invalid" : "") + " btn-group"} role="group" aria-label="">
                                                        <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#SuppliersModal" slot='end'>
                                                            <FontAwesomeIcon icon={faUsers} />
                                                        </button>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="supplier_id" id="supplier_id" value={supplier_id} 
                                                            className={((this.errorVerify("error_supplier_id")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Supplier ID." aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Supplier</small>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="supplier_name">Supplier Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="supplier_name" id="supplier_name" value={supplier_name}
                                                        className="form-control form-control-sm" placeholder="Supplier Name" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="supplier_address">Supplier Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="supplier_address" id="supplier_address" value={supplier_address}
                                                        className="form-control form-control-sm" placeholder="Supplier Address" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="supplier_phone">Supplier Phone</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="supplier_phone" id="supplier_phone" value={supplier_phone}
                                                            className="form-control form-control-sm" placeholder="Supplier Phone" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Phone</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Save</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterSuppliersInvoices"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="SuppliersModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="SuppliersModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="SuppliersModalLabel">Suppliers</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">SUPPLIER</th>
                                                    <th className="align-middle">ADDRESS</th>
                                                    <th className="align-middle">PHONE</th>
                                                    <th className="align-middle">CHOOSE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    suppliers.map((itemSuppliers) => (
                                                        <tr key={itemSuppliers.ID_SUPPLIER }>
                                                            <td>{itemSuppliers.NAME}</td>
                                                            <td>{itemSuppliers.ADDRESS}</td>
                                                            <td>{itemSuppliers.PHONE}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.selectSupplier(
                                                                                itemSuppliers.ID_SUPPLIER,
                                                                                itemSuppliers.NAME,
                                                                                itemSuppliers.ADDRESS,
                                                                                itemSuppliers.PHONE
                                                                            )
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;